import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiDataListModule,
  TuiHintModule,
  TuiTextfieldControllerModule
} from "@taiga-ui/core";
import { TuiInputModule } from "@taiga-ui/kit";
import { KwikUIInputEmailComponent } from "./input-email.component";

@NgModule({
  declarations: [KwikUIInputEmailComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputModule,
    TuiDataListModule,
    TuiTextfieldControllerModule
  ],
  exports: [KwikUIInputEmailComponent]
})
export class KwikUIInputEmailModule {}
